<script setup lang="ts">
import { useRouter } from "vue-router"

import { useSessionStore } from "@/entities/session"

const session = useSessionStore()
const router = useRouter()

function onLogout(): void {
  session.logout()
  router.push({ name: "login" })
}
</script>

<template>
  <button class="rounded border px-3 py-1" type="button" @click="onLogout">Log out</button>
</template>
